import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { SavedFilter } from '../../models/saved-filter.model';
import { SavedFilterService } from '../../services/saved-filter.service';
import { SavedFilterTypeModel } from './saved-filter-type.model';
import { FilterOptionModel } from '../../models/filter-option.model';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { FilterService } from '../../services/abstract-filter.service';

@Component({
    selector: 'agpr-saved-filter-wrapper',
    templateUrl: './saved-filter-wrapper.component.html',
    styleUrls: ['./saved-filter-wrapper.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: SavedFilterWrapperComponent
        }
    ],
    standalone: false
})
export class SavedFilterWrapperComponent extends AbstractFilterTypeComponent implements OnInit, OnDestroy, OnChanges {

    @Input() declare filter: SavedFilterTypeModel;

    filteredOptions: FilterOptionModel[] = [];
    value: SavedFilter[];
    subscrpitions: Subscription[] = [];
    hasFavoriteItems: boolean = false;
    loading: boolean = false;

    searchQuery: string = '';

    readonly severity = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        private savedFilterService: SavedFilterService,
        private filterService: FilterService
    ) {
        super();
    }

    ngOnInit() {
        this.refresh();
        this.subscrpitions.push(
            this.savedFilterService.all$.subscribe(
                filters => {
                    this.filter.options = filters
                        ?.sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
                        ?.sort((a, b) => Number(b.favorite) - Number(a.favorite))
                        ?.map(x => ({ label: x.name, value: x })) || [];

                    this.filteredOptions = this.filter.options.slice();
                    this.hasFavoriteItems = !!this.filteredOptions.find(x => x.value.favorite);

                    if (this.filteredOptions.length && this.filter.getCurrentValue().length) {
                        this.value = this.filter.getCurrentValue().map((val) => {
                            const match = this.filteredOptions.find((option) => option.value.id === val.id);
                            if (match) {
                                return match.value;
                            }
                        }).filter(val => !!val);
                        this.setFilterCards(this.value);
                    }

                    this.search();
                }
            ),

        );
    }

    ngOnChanges() {
        this.searchQuery = '';
        this.refresh();
    }


    refresh(): void {
        this.search();
        this.value = this.filter.getCurrentValue();
    }

    editFavorite(item: SavedFilter) {
        this.loading = true;

        this.savedFilterService.updateFavorite(item.id, !item.favorite).subscribe({
            next: () => this.loading = false,
            error: () => this.loading = false
        });
    }

    /**
     * Filters the visible options based on the search query
     */
    search(): void {
        this.filteredOptions = this.filter.options.filter(
            (listItem) => {
                return listItem.label.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1;
            }
        );
    }


    handleChange(): void {
        this.filter.setCurrentValue(this.value);
        this.setFilterCards(this.value);

    }

    setFilterCards(value: SavedFilter[]) {
        value.forEach(savedFilter => {
            if (this.filter.filterCards.length === 0) {
                this.filter.filterCards.push(
                    this.filterService.constructFilterCardFromValue(savedFilter)
                );
            } else {
                const matchFilterCardIndex = this.filter.filterCards.findIndex(x => x.value.id === savedFilter.id);
                if (matchFilterCardIndex >= 0) {
                    if (JSON.stringify(this.filter.filterCards[matchFilterCardIndex].value) !== JSON.stringify(savedFilter)) {
                        this.filter.filterCards[matchFilterCardIndex] = this.filterService.constructFilterCardFromValue(savedFilter);
                    }
                } else {
                    this.filter.filterCards.push(this.filterService.constructFilterCardFromValue(savedFilter));
                }
            }
        });
        this.filter.filterCards = this.filter.filterCards.filter(x => value.find(savedFilter => x.value.id === savedFilter.id));
    }

    ngOnDestroy() {
        this.subscrpitions.forEach(x => x.unsubscribe());
    }
}
